import { View } from "binder"
import { ToolValidStatus, ToolValidStatusManipulationViewModel } from "./toolValidStatusManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ToolValidStatusManipulationView extends View<ToolValidStatusManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-EA01CE6D-0DB0-4491-9CFD-8BD121375A96"
    }
    loadHtml(): string {
        let element = require('./toolValidStatusManipulation.html').default;
        let style = require('./toolValidStatusManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set toolValidStatus(v: ToolValidStatus) { this._toolValidStatus = v; } public get toolValidStatus(): ToolValidStatus { return this._toolValidStatus; } private _toolValidStatus: ToolValidStatus;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;
}
